import { createOpenAI } from '@ai-sdk/openai';
import { createDeepSeek } from '@ai-sdk/deepseek';
import { createAnthropic } from '@ai-sdk/anthropic';

export const activatedModel = 'openai'; // Change to 'openai', 'anthropic' or 'deepseek' to switch models

function createModelProviderSetup() {
  if (activatedModel == 'deepseek') {
    if (!process.env.REACT_APP_DEEPSEEK_API_KEY) {
      console.warn('DEEPSEEK_API_KEY is not set. AI features will be disabled.');
      return {
        deepseek: null,
      };
    }
  } else if (activatedModel == 'openai') {
    if (!process.env.REACT_APP_OPENAI_API_KEY) {
      console.warn('OPENAI_API_KEY is not set. AI features will be disabled.');
      return {
        openai: null,
      };
    }
  } else if (activatedModel == 'anthropic') {
    if (!process.env.REACT_APP_ANTHROPIC_API_KEY) {
      console.warn('ANTHROPIC_API_KEY is not set. AI features will be disabled.');
      return {
        anthropic: null,
      };
    }
  }

  const openaiProvider = createOpenAI({ apiKey: process.env.REACT_APP_OPENAI_API_KEY });
  const deepseekProvider = createDeepSeek({ apiKey: process.env.REACT_APP_DEEPSEEK_API_KEY });
  const anthropicProvider = createAnthropic({ apiKey: process.env.REACT_APP_ANTHROPIC_API_KEY });

  const models = {
    deepseek: deepseekProvider('deepseek-reasoner'),
    openai: openaiProvider('o4-mini'),
    anthropic: anthropicProvider('claude-3-5-sonnet-20240620'),
  };

  return models;
}

export const models = createModelProviderSetup();
